import React, { useState, useEffect } from 'react';
import { Card, Button, Typography, Spin, message, Form, Input } from 'antd';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { authAPI } from '../api/auth';
import styles from './Invitation.module.css';
import { sanitizePhoneInput } from '../utils/phone';

const { Title, Paragraph, Text } = Typography;

export default function InvitationPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [invitationCode, setInvitationCode] = useState(searchParams.get('code') || '');
  const [stage, setStage] = useState('registration'); // registration, confirmation
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    if (invitationCode) {
      form.setFieldsValue({ invitationCode });
    }
  }, [invitationCode, form]);

  const handleRegister = async (values) => {
    setLoading(true);
    try {
      const response = await authAPI.registerUser(
        values.firstName,
        values.lastName,
        values.phoneNumber,
        values.email,
        values.username,
        values.password
      );

      if (response.data.success) {
        Cookies.set('token', response.data.token, { expires: 30 });
        setUserInfo(response.data.user);
        message.success('حساب شما با موفقیت ایجاد شد!');
        setStage('confirmation');
      }
    } catch (error) {
      message.error(error.response?.data?.message || 'خطا در ثبت‌نام');
    } finally {
      setLoading(false);
    }
  };

  const handleEnterGame = () => {
    navigate('/journey');
  };

  if (stage === 'registration') {
    return (
      <div className={styles.container}>
        <Card className={styles.card}>
          <Title level={1}>🪄 به هاگوارتز خوش آمدید</Title>
          <Paragraph>
            شما به مدرسه جادوگری هاگوارتز دعوت شده‌اید!
          </Paragraph>

          <Form form={form} onFinish={handleRegister} layout="vertical">
            <Form.Item
              name="firstName"
              label="نام"
              rules={[{ required: true, message: 'نام الزامی است' }]}
            >
              <Input placeholder="مثال: هری" />
            </Form.Item>

            <Form.Item
              name="lastName"
              label="نام خانوادگی"
              rules={[{ required: true, message: 'نام خانوادگی الزامی است' }]}
            >
              <Input placeholder="مثال: پاتر" />
            </Form.Item>

            <Form.Item
              name="phoneNumber"
              label="شماره تماس"
              rules={[{ required: true, message: 'شماره تماس الزامی است' }]}
              normalize={sanitizePhoneInput}
            >
              <Input placeholder="09123456789" />
            </Form.Item>

            <Form.Item
              name="email"
              label="ایمیل"
              rules={[{ required: true, type: 'email' }]}
            >
              <Input placeholder="email@example.com" />
            </Form.Item>

            <Form.Item
              name="username"
              label="نام کاربری"
              rules={[{ required: true, message: 'نام کاربری الزامی است' }]}
            >
              <Input placeholder="harry_potter" />
            </Form.Item>

            <Form.Item
              name="password"
              label="رمز عبور"
              rules={[{ required: true, message: 'رمز عبور الزامی است' }]}
            >
              <Input.Password placeholder="رمز عبور" />
            </Form.Item>

            {invitationCode && (
              <Form.Item
                name="invitationCode"
                label="کد دعوت"
                initialValue={invitationCode}
              >
                <Input disabled />
              </Form.Item>
            )}

            <Button type="primary" htmlType="submit" block size="large" loading={loading}>
              ثبت‌نام و ورود
            </Button>
          </Form>

          <Paragraph style={{ marginTop: '20px', textAlign: 'center' }}>
            حساب کاربری دارید؟{' '}
            <Button type="link" onClick={() => navigate('/login')}>
              وارد شوید
            </Button>
          </Paragraph>
        </Card>
      </div>
    );
  }

  if (stage === 'confirmation') {
    return (
      <div className={styles.container}>
        <Card className={styles.card}>
          <Title level={1}>🎁 دعوت‌نامه به هاگوارتز</Title>
          <Title level={2}>خوش آمدید {userInfo?.firstName}!</Title>

          <div className={styles.ticket}>
            <div className={styles.ticketHeader}>🚂 بلیت قطار هاگوارتز اکسپرس 🚂</div>

            <div className={styles.ticketBody}>
              <p><strong>مسافر:</strong> {userInfo?.firstName} {userInfo?.lastName}</p>
              <p><strong>مقصد:</strong> مدرسه جادوگری هاگوارتز</p>
              <p><strong>از ایستگاه:</strong> سکوی ۹¾</p>
              <p><strong>تاریخ حرکت:</strong> ۱ سپتامبر (۱۰ شهریور)</p>
            </div>

            {userInfo?.trainTicketCode && (
              <div className={styles.ticketCode}>
                کد بلیت: <code>{userInfo.trainTicketCode}</code>
              </div>
            )}
          </div>

          <div className={styles.galleons}>
            <Title level={3}>💰 ۵۰ گالیون شما اضافه شد!</Title>
            <Paragraph>
              با این گالیون‌ها می‌توانید وسایل مدرسه را بخرید.
            </Paragraph>
          </div>

          <div className={styles.requirements}>
            <Title level={3}>📚 وسایل مورد نیاز سال اول:</Title>
            <ul>
              <li>ردای مدرسه (مشکی)</li>
              <li>چوبدستی</li>
              <li>کتاب‌های درسی</li>
              <li>وسایل معجون‌سازی (دیگ، ترازو، شیشه معجون)</li>
              <li>و...</li>
            </ul>
          </div>

          <Button
            type="primary"
            size="large"
            onClick={handleEnterGame}
            block
          >
            ورود به بازی
          </Button>

          <Paragraph style={{ marginTop: '20px', textAlign: 'center' }}>
            کد دعوت: <Text code>{invitationCode}</Text>
          </Paragraph>
        </Card>
      </div>
    );
  }
}
